import { ViewModel } from "binder";
import { ButtonElement } from "../components/button/button-viewModel";
import { CheckboxElement } from "../components/checkbox/checkbox-viewModel";
import { ClientFilterTableElement } from "../components/clientFilterTable/clientFilterTable-viewModel";
import { ServerFilteringTableViewModel } from "../components/clientFilterTable/serverFilteringTable-viewModel";
import { ComboViewModel } from "../components/combo/combo-viewModel";
import { ContentElement } from "../components/content/content-viewModel";
import { DataViewModel } from "../components/date/data-viewModel";
import { DummyPlaceHolderElement } from "../components/dummyPlaceHolder/dummyPlaceHolder-viewModel";
import { DummyTablePlaceHolderComponentElement } from "../components/dummyPlaceHolder/dummyTablePlaceHolderComponent/dummyTablePlaceHolderComponent-viewModel";
import { TdElement } from "../components/dummyPlaceHolder/dummyTablePlaceHolderComponent/td/td-viewModel";
import { GridViewModel } from "../components/grid/grid-viewModel";
import { HrViewModel } from "../components/hr/hr-viewModel";
import { InputElement } from "../components/input/input-viewModel";
import { ListViewModel } from "../components/list/list-viewModel";
import { LoadingViewModel } from "../components/loading/loading-viewModel";
import { MultiLineInputViewModel } from "../components/multiLineInput/multiLineInput-viewModel";
import { ScrollViewModel } from "../components/scroll/scroll-viewModel";
import { SpanElement } from "../components/span/span-viewModel";
import { ComponentListStore } from "../formBuilder/templateEditor/templateEditor-viewModel";
import { FormBuilderComponent } from "../structure/components";
import { ChildAcceptableFormBuilderElement, CustomElementProperty, ElementProperty, FormBuilderElement, IFormBuilderElementVisitor } from "../structure/element";
import { BindingPropertyValue, IElementPropertyValueVisitor, StaticPropertyValue, UnsetPropertyValue } from "../structure/propertyValue";
import { FilesListViewModel } from "../components/filesList/filesList-viewModel";
import { ImageElement } from "../components/image/image-viewModel";
import { IconElement } from "../components/icon/icon-viewModel";
import { ExpanderViewModel } from "../components/expander/expander-viewModel";
import { BarcodeReaderViewModel } from "../components/barcodeReader/barcodeReader-viewModel";
import { ChartElement } from "../components/chart/chart-viewModel";
import { GuageElement } from "../components/guage/guage-viewModel";

export class customSerializer implements IFormBuilderElementVisitor,IElementPropertyValueVisitor{
    public serialize(element:FormBuilderElement):any{
        let result = element.Accept(this,null);
        return result;
    }
    private serailizeElement(element:FormBuilderElement):any{
        let visitor = this;
        return {
            ComponentName : element.component.name,
            Properties : element.properties.map(x=>{
                return {
                    PropertyName : x.property.name,
                    Value : x.elementPropertyValue.Accept(visitor,null),
                    ReadableName : x.property.readableName
                }
            })
        }
    }
    private serializeChildContainer(element:ChildAcceptableFormBuilderElement):any{
        let result = this.serailizeElement(element);
        result.Children = element.children.map(x=>this.serialize(x));
        return result;
    }

    VisitGrid(element: GridViewModel, parameter: object): object {
        let result = this.serializeChildContainer(element);
        return result;
    }
    VisitExpander(element: ExpanderViewModel, parameter: object): object {
        let result = this.serializeChildContainer(element);
        return result;
    }
    
    VisitDummyPlaceHolder(element: DummyPlaceHolderElement, parameter: object): object {
        let result = this.serializeChildContainer(element);
        return result;
    }
    VisitInput(element: InputElement, parameter: object): object {
        let result = this.serailizeElement(element);
        return result;
    }
    VisitContent(element: ContentElement, parameter: object): object {
        let result = this.serailizeElement(element);
        return result;
    }
    VisitComboBox(element: ComboViewModel, parameter: object): object {
        let result = this.serailizeElement(element);
        return result;
    }
    VisitSpan(element: SpanElement, parameter: object): object {
        let result = this.serailizeElement(element);
        return result;
    }
    VisitDummyTablePlaceHolderComponentElement(element: DummyTablePlaceHolderComponentElement, parameter: object): object {
        let result = this.serializeChildContainer(element);
        return result;
    }
    VisitTdElement(element: TdElement, parameter: object): object {
        let result = this.serializeChildContainer(element);
        return result;
    }
    VisitClientFilterTable(element: ClientFilterTableElement, parameter: object): object {
        let result = this.serailizeElement(element);
        return result;
    }
    VisitServerFilterTable(element: ServerFilteringTableViewModel, parameter: object): object {
        let result = this.serailizeElement(element);
        return result;
    }
    VisitButton(element: ButtonElement, parameter: object): object {
        let result = this.serializeChildContainer(element);
        return result;
    }
    VisitCheckBox(element: CheckboxElement, parameter: object): object {
        let result = this.serailizeElement(element);
        return result;
    }
    VisitDate(element: DataViewModel, parameter: object): object {
        let result = this.serailizeElement(element);
        return result;    
    }
    VisitChart(element: ChartElement, parameter: object): object {
        let result = this.serailizeElement(element);
        return result;    
    }
    VisitGuage(element: GuageElement, parameter: object): object {
        let result = this.serailizeElement(element);
        return result;    
    }
    VisitHr(element: HrViewModel, parameter: object): object {
        let result = this.serializeChildContainer(element);
        return result;
    }
    VisitList(element: ListViewModel, parameter: object): object {
        let result = this.serailizeElement(element);
        return result;
    }
    VisitLoading(element: LoadingViewModel, parameter: object): object {
        let result = this.serializeChildContainer(element);
        return result;
    }
    VisitMultiLineInput(element: MultiLineInputViewModel, parameter: object): object {
        let result = this.serailizeElement(element);
        return result;
    }
    VisitScroll(element: ScrollViewModel, parameter: object): object {
        let result = this.serializeChildContainer(element);
        return result;
    }
    VisitFilesList(element: FilesListViewModel, parameter: object): object {
        let result = this.serailizeElement(element);
        return result;
    }
    VisitImage(element: ImageElement, parameter: object): object {
        let result = this.serailizeElement(element);
        return result;
    }
    VisitIcon(element: IconElement, parameter: object): object {
        let result = this.serailizeElement(element);
        return result;
    }
    VisitBarcodeReader(element: BarcodeReaderViewModel, parameter: object): object {
        let result = this.serailizeElement(element);
        return result;
    }





    visitUnsetPropertyValue(arg0: UnsetPropertyValue, parameter: object): object {
        return {
            Type : "Unset"
        }
    }
    visitStaticPropertyValue(arg0: StaticPropertyValue, parameter: object): object {
        return {
            Type:"Static",
            Value:arg0.getValue()
        }
    }
    visitBindingPropertyValue(arg0: BindingPropertyValue, parameter: object): object {
        return {
            Type:"Binding",
            Value:arg0.getValue()
        }
    }

}

export class customDeserializer{
    private components : Map<string,FormBuilderComponent>; 
    public deserialize(parent:ViewModel,json:any,dataContext:ViewModel):FormBuilderElement{
        this.components = new Map<string,FormBuilderComponent>();
        new ComponentListStore().listAllComponents(parent).forEach(x=>{
            this.components.set(x.name,x);
        });
        let result = this.create(parent,json,dataContext);
        return result;
    }

    private create(parent:ViewModel,json:any,viewModel? : ViewModel):FormBuilderElement{
        let relatedComponent = this.components.get(json.ComponentName);
        let element = relatedComponent.Create(parent);
        if(viewModel){
            element.DataContext = <any>viewModel;
        }
        if(((<any>parent).canAcceptContent && (<any>parent).canAcceptContent()==true)
            || ((<any>parent).canAcceptContentAtDeserializationTime && (<any>parent).canAcceptContentAtDeserializationTime())
        ){
            (<any>parent).addChild(element);
        }
        json.Properties.forEach(p => {
            if(p.PropertyName.startsWith('CUSTOM-PROPERTY-')){
                CustomElementProperty.createPropertyWithName(element,p.ReadableName,p.PropertyName);
            }
            let property : ElementProperty = element.findPropertyByName(p.PropertyName);
            let value = p.Value;
            if(property!=null){
                if(value.Type=="Unset"){
                    property.unsetValue();
                }else if(value.Type=="Static"){
                    property.setStaticValue(value.Value);
                }else{
                    property.setBinding(value.Value);
                }
            }
        });
        if(json.Children!=null){
            json.Children.forEach(x=>{
                this.create(element.self,x);
            })
        }
        return element;
    }


}